import React from 'react';
import PropTypes from 'prop-types';
import mFinance from 'models/cpm/finance';
import mPriceGrid from 'models/cpm/priceGrid';
import _get from 'lodash/get';
import Tooltip from 'components/core/Tooltip';
import { useIntl } from 'react-intl';
import Badge from './components/Badge/Badge';
import styles from './style.cssmodule.css';

const formatPrice = (priceInCentimes, currency) => {
  const price = priceInCentimes / 100;
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency,
  }).format(price);
};

function Payment({ parking }) {
  const { purchases, status } = parking;
  const { formatMessage: t } = useIntl();

  if (!purchases || purchases.length === 0) return null;

  const lastPurchase = (purchases && purchases.at(-1)) || null;

  const paid = /^paid$/i.test(lastPurchase.paymentStatus);
  const required = /^required$/i.test(lastPurchase.paymentStatus) && lastPurchase.totalAmountInclTax > 0;
  const cancelled = /^cancelled$/i.test(lastPurchase.paymentStatus);
  const free = purchases.every(({ type }) => /^free$/i.test(type));
  const priceGridFree = parking.priceGrid ? mPriceGrid.priceGridIsFree(parking.priceGrid) : false;
  const zero = purchases.every(({ totalAmountInclTax }) => totalAmountInclTax === 0);
  const overstay = /^in_overstay$/i.test(status);
  const refunded = purchases.some(({ paymentStatus }) => /^refunded$/i.test(paymentStatus))
    && purchases.every(({ paymentStatus }) => /^refunded$/i.test(paymentStatus) || /^cancelled$/i.test(paymentStatus));
  const needsToPayLastPurchase = !(mFinance.purchaseIsFree(lastPurchase) || mFinance.purchaseIsZero(lastPurchase))
    && mFinance.purchasePaymentIsRequired(lastPurchase)
    && mFinance.purchasePaymentCanBeValidated(lastPurchase);

  const lastPurchaseIsCancelled = mFinance.purchasePaymentIsCancelled(lastPurchase);

  const priceGridIsFree = parking.priceGrid ? mPriceGrid.priceGridIsFree(parking.priceGrid) : false;

  /* ---------------- */

  const type = 'info';
  let message = t({ id: 'onDemand.paymentStatus.unknownStatus' });

  const lastPurchaseCurrency = _get(lastPurchase, 'priceRule.currency', 'EUR');
  const totalAmountInclTax = formatPrice(mFinance.purchaseSumPaidAmount(purchases), lastPurchaseCurrency);

  /* 🆓 Free */
  if (free || priceGridFree || zero) {
    return (
      <Tooltip content={t({ id: 'info.freePayment' })} className={styles.badgeWrapper}>
        <Badge type="success" className={styles.badgeWrapper}>
          {totalAmountInclTax}
        </Badge>
      </Tooltip>
    );
  }

  /* ✅ Paying and all paid */
  if (paid && !overstay) {
    return (
      <Badge type="success" className={styles.badgeWrapper}>
        {totalAmountInclTax}
      </Badge>
    );
  }

  /* ⚠️ Last payment cancelled */
  if (cancelled) {
    message = t({ id: 'onDemand.paymentStatus.cancelled' });
    return (
      <Tooltip content={t({ id: 'info.paymentCancelledByUserOrSystem' })} className={styles.badgeWrapper}>
        <Badge type="warning">{message}</Badge>
      </Tooltip>
    );
  }

  if (needsToPayLastPurchase || lastPurchaseIsCancelled) {
    message = t({ id: 'onDemand.paymentStatus.cancelled' });
    return (
      <Tooltip content={t({ id: 'info.paymentCancelledByUserOrSystem' })} className={styles.badgeWrapper}>
        <Badge type="warning">{message}</Badge>
      </Tooltip>
    );
  }

  /* ⏳ Waiting for payment */
  if (overstay && !priceGridIsFree) {
    message = t({ id: 'onDemand.paymentStatus.waiting' });
    return (
      <Tooltip content={t({ id: 'info.pendingPayment' })} className={styles.badgeWrapper}>
        <Badge type="waiting">{message}</Badge>
      </Tooltip>
    );
  }

  /*  ↪️ Refunded */
  if (refunded) {
    message = t({ id: 'onDemand.paymentStatus.refunded' });
    return (
      <Tooltip content={t({ id: 'info.refundedByUserOrSystem' })} className={styles.badgeWrapper}>
        <Badge type="refunded">{message}</Badge>
      </Tooltip>
    );
  }

  if (required) {
    message = t({ id: 'onDemand.paymentStatus.waiting' });
    return (
      <Tooltip content={t({ id: 'info.parkingRequiredPayment' })} className={styles.badgeWrapper}>
        <Badge type="waiting">{message}</Badge>
      </Tooltip>
    );
  }

  // ❓Unknown payment status
  return (
    <Badge type={type} className={styles.badgeWrapper}>
      {message}
    </Badge>
  );
}

Payment.propTypes = {
  parking: PropTypes.object,
};

Payment.defaultProps = {
  parking: {},
};
export default Payment;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/Payment/Payment.jsx